const { useI18n } = require('nordic/i18n');
const { Button } = require('@andes/button');
const classNames = require('classnames');

const translate = require('../../../translation');

const FooterAction = ({
  isMobile,
  continueAction,
  isContinueActionVisible,
  className,
}) => {
  const { i18n } = useI18n();
  const translations = translate(i18n);

  return (
    <section className={classNames('d-flex d-flex-column', className)}>
      <section
        className={classNames(
          'd-flex',
          isMobile
            ? 'd-flex-column'
            : 'd-flex-justify-end d-flex-row-reverse g-8',
        )}
      >
        {isContinueActionVisible ? (
          <Button
            hierarchy="loud"
            size="large"
            type={continueAction ? 'button' : 'submit'}
            fullWidth={isMobile}
            onClick={continueAction}
          >
            {translations.CONTINUE}
          </Button>
        ) : undefined}

        <Button
          hierarchy="quiet"
          size="large"
          onClick={() => window.history.back()}
          fullWidth={isMobile}
        >
          {translations.TO_GO_BACK}
        </Button>
      </section>
    </section>
  );
};

module.exports = { FooterAction };
